var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95996 6.0127C9.11055 6.01042 9.24763 6.04851 9.37109 6.12793L9.49023 6.22168C9.64309 6.37462 9.71868 6.54956 9.71875 6.74707C9.71875 6.9446 9.64329 7.12038 9.49023 7.27344L6.16113 10.6025H15.5684C16.8778 10.6026 17.9945 11.0646 18.9189 11.9893C19.8435 12.9137 20.3057 14.0304 20.3057 15.3398V18.0898C20.3056 18.2994 20.2349 18.4743 20.0938 18.6152C19.9528 18.7564 19.778 18.8271 19.5684 18.8271C19.3588 18.8271 19.184 18.7563 19.043 18.6152C18.9018 18.4743 18.8311 18.2994 18.8311 18.0898V15.3398C18.8311 14.4391 18.5119 13.67 17.875 13.0332C17.2382 12.3962 16.4691 12.0772 15.5684 12.0771H6.16113L9.50586 15.4219C9.65203 15.5684 9.7236 15.739 9.72168 15.9346C9.71988 16.1301 9.64305 16.304 9.49023 16.457C9.33712 16.5999 9.1645 16.6736 8.97168 16.6787C8.77959 16.6836 8.60712 16.6108 8.4541 16.458L3.95996 11.9639C3.78137 11.7853 3.69244 11.5772 3.69238 11.3398C3.69238 11.1024 3.78131 10.8945 3.95996 10.7158L8.4541 6.22168C8.5902 6.08575 8.75871 6.01598 8.95996 6.0127Z",
    fill: "#0069AA",
    stroke: "#0069AA",
    strokeWidth: 0.025
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResend);
export default __webpack_public_path__ + "static/media/resend.218655df0dd18ac22e6648e8c7bd485d.svg";
export { ForwardRef as ReactComponent };